import { Selection, Summary } from "../data-types";

const calculateTotal = (item: string, selection: Selection) => {
  const matchName = selection.sum.filter((e) => e.subject === item);
  const hasName = selection.sum.filter((e) => e.subject.includes(item) && item);
  if (matchName.length > 0) {
    return matchName[0].total;
  } else if (hasName.every((e) => typeof e.total === "number")) {
    return hasName.reduce((prev, current) => prev + current.total, 0);
  } else {
    return 0;
  }
};

const calculateOwe = (summary: Summary) => {
  // Salary Input
  const bcIncome = 57477.84; //56745;
  const jlIncome = 90103.68; //63110.64;
  const bcSpent = calculateTotal("BC", summary.BCJL);
  const jlSpent = calculateTotal("JL", summary.BCJL);
  const bcjlSpent = calculateTotal("BCJL", summary.BCJL);
  const bcjl5050Spent =
    calculateTotal("BCJL (50/50)", summary.BCJL) +
    calculateTotal("BC/JL (50/50)", summary.BCJL);
  const bcPaid =
    calculateTotal("BC", summary.bank) -
    calculateTotal("Not Include BC", summary.BCJL);
  const jlPaid =
    calculateTotal("JL", summary.bank) -
    calculateTotal("Not Include JL", summary.BCJL);
  const bcOweJl =
    jlPaid -
    jlSpent -
    (bcjlSpent * jlIncome) / (bcIncome + jlIncome) -
    bcjl5050Spent / 2;
  const jlOweBc =
    bcPaid -
    bcSpent -
    (bcjlSpent * bcIncome) / (bcIncome + jlIncome) -
    bcjl5050Spent / 2;
  return { bcOweJl, jlOweBc };
};

export { calculateOwe };
